import type { ReactNode } from 'react';

/** Page heading of the mock-ups: 26px black title, muted subtitle, actions on the right. */
export function PageTitle({ title, subtitle, back, children }: { title: ReactNode; subtitle?: ReactNode; back?: ReactNode; children?: ReactNode }) {
  return (
    <div className="flex flex-col gap-2.5">
      {back}
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div className="flex min-w-0 flex-col gap-1">
          <h1 className="m-0 text-[26px] font-black tracking-[-0.01em]">{title}</h1>
          {subtitle && <p className="m-0 text-sm text-muted-foreground">{subtitle}</p>}
        </div>
        {children && <div className="flex flex-wrap items-center gap-2.5">{children}</div>}
      </div>
    </div>
  );
}
